
import { useState, useCallback } from 'react';
import { CRMUser } from '@/types/crm';
import { UserState } from './types';

export const useUserState = (): UserState & {
  setUsers: (users: CRMUser[]) => void;
  setSelectedUser: (user: CRMUser | null) => void;
  setIsLoading: (loading: boolean) => void;
  setSearchQuery: (query: string) => void;
  setProcessingUsers: (users: string[]) => void;
} => {
  const [users, setUsers] = useState<CRMUser[]>([]);
  const [selectedUser, setSelectedUser] = useState<CRMUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [processingUsers, setProcessingUsers] = useState<string[]>([]);

  return {
    users,
    selectedUser,
    isLoading,
    searchQuery,
    processingUsers,
    setUsers,
    setSelectedUser,
    setIsLoading,
    setSearchQuery,
    setProcessingUsers,
  };
};
